import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="footer-logo">
            <span>⚡</span>
            <span className="logo-text">SPORTIX</span>
          </div>
          <p>منصة التوظيف والخدمات الرياضية الرائدة. نربط المحترفين الرياضيين بالفرص الأمثل.</p>
          <div className="footer-social">
            <a href="#" aria-label="Twitter">𝕏</a>
            <a href="#" aria-label="LinkedIn">in</a>
            <a href="#" aria-label="Instagram">📷</a>
          </div>
        </div>
        <div className="footer-col">
          <h4>الوظائف</h4>
          <Link to="/jobs?job_type=full_time">وظائف دوام كامل</Link>
          <Link to="/jobs?job_type=part_time">وظائف جزئية</Link>
          <Link to="/jobs?job_type=freelance">عمل حر</Link>
          <Link to="/jobs?is_remote=true">عمل عن بُعد</Link>
        </div>
        <div className="footer-col">
          <h4>المنصة</h4>
          <Link to="/professionals">المحترفون</Link>
          <Link to="/organizations">المؤسسات</Link>
          <Link to="/services">الخدمات الرياضية</Link>
          <Link to="/post-job">نشر وظيفة</Link>
        </div>
        <div className="footer-col">
          <h4>الشركة</h4>
          <Link to="/about">من نحن</Link>
          <Link to="/privacy">سياسة الخصوصية</Link>
          <Link to="/terms">الشروط والأحكام</Link>
          <Link to="/contact">تواصل معنا</Link>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} SPORTIX. جميع الحقوق محفوظة.</p>
        <p>صُنع بـ ❤️ للقطاع الرياضي</p>
      </div>
    </div>
  </footer>
);

export default Footer;
